// libraries.
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

// types.
import { ActionTaskEnum } from '../../DocumentsAuditDashboard/components/DocumentsTable/TaskAction';

// slices.
import {
  getSelectedTasks,
  setSelectedTasks,
} from '@domains/documents-review/store/slices/document-review-slice';

// styles.
import { WrapperCheckInput } from './styles';
import { TaskItem } from '@domains/documents-review/interfaces/interfaces';

interface SelectTasksProps {
  rowTask: TaskItem;
}

export const SelectTasks = ({ rowTask }: SelectTasksProps) => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getSelectedTasks);

  const handleChange = () => {
    dispatch(setSelectedTasks(rowTask.id));
  };

  if (rowTask.action !== ActionTaskEnum.PENDING) return null;

  return (
    <WrapperCheckInput>
      <Form.Check
        type="checkbox"
        checked={selectedIds?.includes(rowTask.id)}
        onChange={handleChange}
      />
    </WrapperCheckInput>
  );
};
